import Model, { getWebtexte } from "./model";
import Gateway from "@phoenixreisen/gateway";
import ErrorPage from "./components/error.m";
import ResetHub from "./components/reset.hub.m";
import ResetNew from "./components/reset.new.m";
import ResetDone from "./components/reset.done.m";
import PageLayout from "./layout/layout.page.m";
import Login from "./components/login.m";
import Reset from "./components/reset.m";
import Box from "./layout/layout.box.m";
import User from "@phoenixreisen/user";
import DateTime from "date-and-time";
import Hub from "./components/hub.m";
import m from "mithril";
import "date-and-time/locale/de";
import "./index.scss";
(() => {
    const { env } = process;
    DateTime.locale("de");
    Gateway.setApiErrorUrl(env.API_ERROR);
    Gateway.setApiUrl(`${env.GATEWAY}/call-json-service`);
    User.setJWTKey("jwt");
    User.load();
    if (!Model.webtexte) {
        getWebtexte()
            .then((result) => {
            Model.webtexte = result;
            m.redraw();
        })
            .catch(() => {
            m.route.set("/error");
        });
    }
    m.route(document.body.querySelector("#root"), "/", {
        "/": {
            onmatch: () => User.logout(),
            render: () => [m(Box, { key: "root" }, m(Login))],
        },
        "/hub": {
            onmatch: () => !User.isLoggedIn() && m.route.set("/"),
            render: () => [m(PageLayout, { key: "hub" }, m(Hub))],
        },
        "/zuruecksetzen": {
            onmatch: () => User.logout(),
            render: () => [m(Box, { key: "reset" }, m(Reset))],
        },
        "/zuruecksetzen/neu": {
            onmatch: () => !User.isLoggedIn() && m.route.set("/"),
            render: () => [m(Box, { key: "new" }, m(ResetNew))],
        },
        "/zuruecksetzen/temp/:jwt": {
            onmatch: (params) => User.login(params.jwt),
            render: () => [m(Box, [m(ResetHub)])],
        },
        "/zurueckgesetzt/:channel": {
            render: () => [m(Box, [m(ResetDone)])],
        },
        "/error": {
            render: () => [m(Box, { key: "error" }, m(ErrorPage))],
        },
        "/:app": {
            onmatch: () => User.logout(),
            render: () => [
                m(Box, { key: "root" }, m(Login, { app: m.route.param("app") })),
            ],
        },
    });
})();
